export default __webpack_public_path__ + "static/media/thumbpics1.5c871722.jpg";